/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import type { ReferralInsurance } from "../api/referrals";
import { Input } from "./ui/Input";

/** The insurance hint a referral carries: the plan, the member id, the group number. */
export function InsuranceFields({
  value,
  onChange,
  errors,
}: {
  value: ReferralInsurance;
  onChange: (next: ReferralInsurance) => void;
  errors?: (field: string) => string | undefined;
}) {
  const set = (key: keyof ReferralInsurance) => (next: string) =>
    onChange({ ...value, [key]: next.trim() === "" ? null : next });
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      <Input
        label="Insurance plan"
        value={value.payerName ?? ""}
        error={errors?.("insurance.payerName") ?? ""}
        onChange={(event) => set("payerName")(event.target.value)}
      />
      <Input
        label="Member ID"
        value={value.memberId ?? ""}
        error={errors?.("insurance.memberId") ?? ""}
        onChange={(event) => set("memberId")(event.target.value)}
      />
      <Input
        label="Group number"
        value={value.groupNumber ?? ""}
        error={errors?.("insurance.groupNumber") ?? ""}
        onChange={(event) => set("groupNumber")(event.target.value)}
      />
    </div>
  );
}
